import { useSelector } from "react-redux";

import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { selectOpportunityListOptionById } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type { OpportunityListOption } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

export const useActiveListOption = (): OpportunityListOption | undefined => {
    const listParams = useListParams();

    return useSelector((state) => selectOpportunityListOptionById(state, listParams.id));
};
